import React from 'react';
import PropTypes from 'prop-types';
import ProfessionChart from './ProfessionChart';
import ProfessionTable from './ProfessionTable';
import { BaseCard } from '@bvt-shared/component/BaseCard';
import './CardProfession.scss';

/**
 *
 * @param {object} props
 * @param {Array<{
 * name: string
 * total: number
 * }>} props.topSix
 * @param {Array<{
 * name: string
 * total: number
 * icon: string
 * }>} props.other
 * @param props.isNoData
 * @param {string} props.title
 */

export default function Profession(props) {
  return (
    <div id={props.id} style={props?.style}>
      <BaseCard
        isLoading={props?.isLoading}
        title={props.title || 'Profession'}
        withPadding={true}
      >
        {props.isNoData && (
          <div className='feature-griana Profession_no-content'>No Available Data</div>
        )}
        {!props.isNoData && (
          <>
            <div
              className='feature-griana Profession'
              style={
                props.bordered && {
                  border: '1px solid #E5E5E5',
                  padding: '0.25rem 0.5rem',
                }
              }
            >
              <div className='feature-griana Profession--title'>
                  Top 6 Profession in area
              </div>
              <ProfessionChart data={props.topSix} />
              <ProfessionTable data={props.other} />
            </div>
            {props.bordered && (
              <div className='feature-griana Profession--info'>
                  Data source : <b>Kemendagri Dukcapil</b>
              </div>
            )}
          </>
        )}
      </BaseCard>
    </div>
  );
}

Profession.propTypes = {
  other: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      total: PropTypes.number,
      icon: PropTypes.string,
    })
  ),
  topSix: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      total: PropTypes.number,
    })
  ),
};
